import { configureStore } from '@reduxjs/toolkit';

import blockchainReducer from './slices/blockchain';
import categoriesReducer from './slices/categories';
import collectionsReducer from './slices/collections';
import counterReducer from './slices/counter';
import leaderboardReducer from './slices/leaderboard';
import seasonReducer from './slices/seasons';
import friendsReducer from './slices/friends';
import hacksReducer from './slices/hacks';
import messageReducer from './slices/messages';
import navigationReducer from './slices/navigation';
import networkReducer from './slices/network';
import levelStandingsReducer from './slices/levelStandings';
import rewardsReducer from './slices/rewards';
import shopReducer from './slices/shop';
import skinsReducer from './slices/skins';
import userReducer from './slices/user';

const reducer = {
	blockchain: blockchainReducer,
	categories: categoriesReducer,
	collections: collectionsReducer,
	counter: counterReducer,
	friends: friendsReducer,
	hacks: hacksReducer,
	message: messageReducer,
	navigation: navigationReducer,
	levelStandings: levelStandingsReducer,
	network: networkReducer,
	rewards: rewardsReducer,
	shop: shopReducer,
	skins: skinsReducer,
	user: userReducer,
	leaderboard : leaderboardReducer,
	seasons: seasonReducer,
};

const store = configureStore({
	reducer,
	devTools: true,
});

export default store;
export type RootState = ReturnType<typeof store.getState>;
export type Dispatch = typeof store.dispatch;
